import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { apiService } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';
import MDEditor from '@uiw/react-md-editor';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

function MadingDetail() {
    const { slug } = useParams();
    const [madingData, setMadingData] = useState(null);
    const [artikel, setArtikel] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const fetchMadingDetail = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await apiService.getMadingDetail(slug);
                
                if (response.data && response.data.article) {
                    setArtikel(response.data.article);
                } else {
                    setError('Artikel tidak ditemukan');
                }
            } catch (err) {
                const errorMessage = err.response?.data?.message || 'Gagal memuat artikel';
                setError(errorMessage);
                console.error('Error fetching article:', err);
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            fetchMadingDetail();
        }
    }, [slug]);

    if (loading) return <div className='min-h-screen flex justify-center items-center '><LoadingSpinner  /></div>;
    if (error) return <div className="text-center text-red-500 p-4">{error}</div>;
    if (!artikel) return <div className="p-6 text-red-500">Artikel tidak ditemukan.</div>;

    return (
        <div className="min-h-screen bg-gray-100 lg:pt-24 pt-24 justify-center space-y-4">
            <div className="max-w-4xl mx-auto text-center lg:px-0 px-6">
                <h1 className="lg:text-4xl text-base font-bold text-center my-2">
                    {artikel.MadingDataJudul}
                </h1>
                <p className="text-body text-gray-500 max-w-3xl mx-auto">
                    Dibuat Oleh {artikel.MadingDataPembuat} <br />
                    {new Date(artikel.MadingDataTanggal).toLocaleDateString('id-ID')}
                </p>
            </div>
            
            {artikel.MadingDataImage && artikel.MadingDataImage.length > 0 && (
                <div className="max-w-xl mx-auto transition-all duration-500 ease-in-out">
                    <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                    <Swiper
                        modules={[Navigation, Pagination, Autoplay, EffectFade]}
                        spaceBetween={0}
                        slidesPerView={1}
                        loop={true}
                        autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                        }}
                        effect="fade"
                        navigation
                        pagination={{ clickable: true }}
                        className="h-64 lg:h-[300px]"
                    >
                        {artikel.MadingDataImage.map((imageUrl, index) => (
                        <SwiperSlide key={index}>
                            <div className="relative h-full">
                            <img
                                src={imageUrl}
                                alt={`${artikel.MadingDataJudul} - Image ${index + 1}`}
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                                <h3 className="text-xl font-bold mb-2">{artikel.MadingDataJudul}</h3>
                                {/* <p className="opacity-90">{slide.description}</p> */}
                            </div>
                            </div>
                        </SwiperSlide>
                        ))}
                    </Swiper>
                    </div>
                </div>
            )}
            
            <div className="max-w-6xl mx-2 lg:mx-auto bg-white shadow-md rounded-lg lg:p-6 p-4 mb-8 border-2 border-teal-100 bg-gradient-to-br from-teal-50 ">
                <MDEditor.Markdown
                    source={artikel.MadingDataIsi}                    
                    className="bg-transparent text-gray-700 lg:text-body text-xs"
                />
            </div>
            
            <div className="flex justify-center mt-6 mb-10 space-x-4">
                <Link
                    to="/"
                    className="text-left px-3 py-2 rounded-md lg:text-base text-sm font-medium bg-primary-600 text-white hover:bg-primary-700 transition-colors flex items-center"
                >
                    🏠 Beranda
                </Link>
                <Link
                    to="/mading"
                    className="text-left px-3 py-2 rounded-md lg:text-base text-sm font-medium bg-primary-600 text-white hover:bg-primary-700 transition-colors flex items-center"
                >
                    Daftar Mading
                </Link>
            </div>
        </div>
    );
}

export function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export default MadingDetail;